export const API_BASE_URL = `https://api-book.viteapp.co/api/v1`;
export const API_PAYMENT_GATEWAY_BASE_URL = `https://mcb.gateway.mastercard.com`;
export const API_KEY = 'bm5lWpycpVKCpehIBDXQH0idgBJvOvwsmqQSipiIFPDDXiyRMnp5ZW2yHsHj8mVo-RLR860hEBpAofdIiHxyPHh170ySyFygH';
export const ApiConfig = {
  createNoAuthScheduledTask: `${API_BASE_URL}/task/createNoAuthScheduledTask`,
  registerDriver: `${API_BASE_URL}/driver/register`,
  calculateFare: `${API_BASE_URL}/task/calculateFare`,
  createCheckoutSession: `${API_PAYMENT_GATEWAY_BASE_URL}/api/nvp/version/61`
};
